import { Divider, FormControlLabel, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import useStyles from "../../../style/js-style/containers/dashboard/RiskSubScoresPieChartStyle";
import i18next from "i18next";
import { useEffect, useMemo, useState } from "react";
import EAIcon from "components/common/EAIcon";
import EAPieChart from "components/common/charts/EAPieChart";

const RiskSubScoresPieChart = ({title, riskLabel, subScores}) => {
    const { classes } = useStyles();

    const [subScoreSelected, setSubScoreSelected] = useState("");

    useEffect(() => {
        if(subScores) {
            setSubScoreSelected(subScores[0]?.scoreLabel)
        }
    }, [subScores])

    const selectData = useMemo(() => (
        subScores.find(score => score.scoreLabel === subScoreSelected)?.data
    ), [subScoreSelected, subScores]);


    return (
        <Paper className={classes.graphPaper}>
        <Typography variant="h3" className={classes.graphAreaTitle}>
          {title}
        </Typography>
        <Divider style={{margin: "0 -20px"}}/>
        <RadioGroup row name="radio-buttons-sub-scores" 
            className={classes.subScoresSelection}
            value={subScoreSelected ?? ""} 
            onChange={(event) => setSubScoreSelected(event.target.value)}
        >
            {subScores.map(score => {
                return (
                    <FormControlLabel key={score.scoreLabel} value={score.scoreLabel} control={<Radio />} label={score.scoreLabel}  />
                )
            })}
        </RadioGroup>

        {selectData?.total === "0" &&
            <div  className={classes.pieNoDataContainer}  style={{ display: "flex"}} >
            <EAIcon icon="search_off" />
            <div className={classes.pieNoDataText}>
              <span className={classes.bolder}>{i18next.t("dashboard.thirdparties.noFilterData")}</span>
            </div>
          </div>
        }
        {selectData?.total !== "0" &&
        <EAPieChart id={`subscores-${riskLabel}-chart`}  data={selectData} tab={"risks"} subTab={riskLabel}
        variant="subscores" 
        />
        }       
      </Paper>
    )

}

export default RiskSubScoresPieChart;